import Vue from 'vue'
import Vuex from 'vuex'

import root from '@/store/modules/root'
import calculation from '@/store/modules/calculation'
import speedCalculation from '@/store/modules/speedCalculation'
import speedCalculation2 from '@/store/modules/speedCalculation2'
import directCalculation from '@/store/modules/directCalculation'
import permission from '@/store/modules/permission'
import favorite from '@/store/modules/favorite'
import { guide } from '@/store/modules/guide'
import { appSidebar } from '@/store/modules/appSidebar'

Vue.use(Vuex)
Vue.config.devtools = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
  modules: {
    root,
    calculation,
    speedCalculation,
    directCalculation,
    permission,
    favorite,
    appSidebar,
    guide,
    speedCalculation2
  },
  strict: process.env.NODE_ENV !== 'production'
})
